import React from 'react'
import style from "../Content.module.css";
import {Table, Space, Input, InputNumber, Form, Button, message, Modal, Select, Checkbox, Row, Col} from "antd";
import {ExclamationCircleOutlined} from '@ant-design/icons'
import Axios from "../../../utils/axios";
import Util from "../../../utils/utils";
import ResizableTitle from "../../../utils/ResizableTitle";
import {fetchAllIdsInParallel} from "../../../utils/fetchAllIds";

const {TextArea} = Input;

class SiteInfo extends React.Component {
    addFormRef = React.createRef();
    viewFormRef = React.createRef();
    editFormRef = React.createRef();
    state = {
        data: null,
        siteName: '',
        status: '',
        remarks: '',
        chargeAmounts: null,
        workTimes: null,
        introduces: null,
        specialRemarks: null,
        vehicleOptions: null,
        filterOptions: null,
        loading: true,
        visible: false,
        viewVisible: false,
        editVisible: false,
        current: 1,
        pageSize: 10,
        total: 0,
        businessUser: null,
        selectedRowKeys: [],
        isExporting: false,
        userPermission: null,
        selected: [],
        checkboxText: '全选',
        isCheckAll: false,
        selectAllProgress: 0,
        selectAllLoading: false,
        colWidths: {},
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }

    componentDidMount() {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (!Util.isEmpty(userName)) {
            this.initData();
            this.getUserPermission();
            this.initFilterOptions();
        }
    }

    initFilterOptions = () => {
        Axios({
            method: 'get',
            url: '/site/listSiteFilterOptions',
        }).then(res => {
            if (res.status === 200 && res.data.code === 200) {
                this.setState({
                    filterOptions: res.data.data,
                });
            }
        }).catch(err => {
            console.log(err);
        });
    }

    filterChange = (key) => (value) => {
        this.setState({
            [key]: value,
        }, () => {
            this.searchSite();
        });
    }

    getUserPermission = () => {
        Axios({
            method: 'get',
            url: '/menu/getUserMenu/' + JSON.parse(window.sessionStorage.getItem("userName")),
        }).then(res => {
            if (res.data.code === 200) {
                this.setState({
                    userPermission: res.data.data,
                });
            } else {
                message.error(res.data.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    exportAllSelect = (e) => {
        this.setState({
            isCheckAll: e.target.checked,
            selectAllProgress: 0,
        })
        if (e.target.checked) {
            const hide = message.loading('正在全选，请稍候…', 0);
            this.setState({selectAllLoading: true});
            const afterDone = () => {
                hide();
                this.setState({selectAllLoading: false});
            };
            const success = (ids) => {
                afterDone();
                if (Array.isArray(ids) && ids.length > 0) {
                    this.setState({
                        selectedRowKeys: ids.sort(function (a, b) {
                            return a - b
                        }),
                        checkboxText: '取消全选',
                        selectAllProgress: 100,
                    });
                    message.success('已全选 ' + ids.length + ' 个站点');
                } else {
                    this.setState({isCheckAll: false});
                    message.info('没有符合要求的数据');
                }
            };
            const fail = (msg) => {
                afterDone();
                this.setState({isCheckAll: false, selectAllProgress: 0});
                if (msg) {
                    message.info(msg);
                } else {
                    message.error('全选失败，请重试');
                }
            };
            // 并发分批拉取所有符合条件的站点ID，实时更新进度百分比
            const PAGE_SIZE = 2000;
            const fetchPage = (pageNum) => {
                return new Promise((resolve, reject) => {
                    Axios({
                        method: 'get',
                        url: '/site/listSiteIdsPage',
                        params: Object.assign({
                            siteName: this.state.siteName,
                            status: this.state.status,
                            remarks: this.state.remarks,
                        }, {pageNum: pageNum, pageSize: PAGE_SIZE}),
                    }).then(res => {
                        if (res.status === 200 && res.data.code === 200) {
                            const data = res.data.data;
                            resolve({
                                total: data ? (Number(data.total) || 0) : 0,
                                list: (data && Array.isArray(data.list)) ? data.list : []
                            });
                        } else if (res.status === 200 && res.data.code === 401) {
                            reject(new Error('401'));
                        } else {
                            reject(new Error(res.data.message || '没有符合要求的数据'));
                        }
                    }).catch(err => {
                        reject(err);
                    });
                });
            };
            fetchAllIdsInParallel(fetchPage, PAGE_SIZE, percent => {
                this.setState({selectAllProgress: percent});
            }).then(ids => {
                success(ids);
            }).catch(err => {
                console.log(err);
                let msg = '';
                if (err && err.message) {
                    msg = err.message;
                } else if (err && err.data) {
                    msg = err.data.message || err.data.msg || '';
                } else if (err && err.status) {
                    msg = '请求失败(' + err.status + ')';
                }
                fail(msg && msg !== '401' ? msg : undefined);
            });
        } else {
            const selected = this.state.selected;
            this.setState({
                selectedRowKeys: selected,
                checkboxText: '全选',
                selectAllProgress: 0,
            });
        }
    }

    initData() {
        Axios({
            method: 'get',
            url: '/site/listSite',
            params: {
                siteName: this.state.siteName,
                status: this.state.status,
                remarks: this.state.remarks,
                chargeAmounts: this.state.chargeAmounts,
                workTimes: this.state.workTimes,
                introduces: this.state.introduces,
                specialRemarks: this.state.specialRemarks,
                vehicleOptions: this.state.vehicleOptions,
                pageNum: this.state.current,
                pageSize: this.state.pageSize
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    this.setState({
                        data: res.data.data.list,
                        loading: false,
                        total: res.data.data.total,
                    });
                } else {
                    this.setState({
                        loading: false,
                    });
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                this.setState({
                    loading: false,
                });
                message.error(res.message);
            }
        }).catch(err => {
            this.setState({
                loading: false,
            });
            console.log(err);
        });
    }

    inputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        }, () => {
            this.searchSite();
        });
    }
    searchSite = () => {
        this.setState({
            loading: true,
        });
        this.initData();
    }
    openAddSiteModal = () => {
        this.setState({
            visible: true,
        });
        setTimeout(() => {
            this.listBusinessUser(null);
        }, 100);
    }
    listBusinessUser = (userName) => {
        Axios({
            method: 'get',
            url: '/user/listBusinessUser',
            params: {
                distribution: false,
                userName: userName,
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    this.setState({
                        businessUser: res.data.data,
                    });
                } else {
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                message.error(res.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    resetSearch = () => {
        this.setState({
            siteName: '',
            status: '',
            remarks: '',
            chargeAmounts: null,
            workTimes: null,
            introduces: null,
            specialRemarks: null,
            vehicleOptions: null,
            loading: true,
        });
        // 重置后按清空条件重新加载数据（loading 提供过程感知）
        setTimeout(() => {
            this.initData();
        }, 100);
    }
    addSite = () => {
        this.addFormRef.current.validateFields()
            .then(values => {
                if (Array.isArray(values.vehicleOption)) {
                    values.vehicleOption = values.vehicleOption.join(',');
                }
                let formData = new FormData();
                formData.append('site', new Blob([JSON.stringify(values)], {type: "application/json"}));
                Axios({
                    method: 'post',
                    url: '/site/addSite',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    data: formData,
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            this.setState({
                                loading: true,
                                visible: false,
                            });
                            message.success(res.data.message);
                            this.initData();
                            this.addFormRef.current.resetFields();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            })
            .catch(info => {
                console.log(info);
            });
    }
    statusChange = (value) => {
        this.setState({
            status: value,
        }, () => {
            this.searchSite();
        })
    }
    handleCancel = () => {
        this.setState({
            visible: false,
            viewVisible: false,
            editVisible: false,
        });
        if (this.addFormRef.current != null) {
            this.addFormRef.current.resetFields();
        }
        if (this.editFormRef.current != null) {
            this.editFormRef.current.resetFields();
        }
        if (this.viewFormRef.current != null) {
            this.viewFormRef.current.resetFields();
        }
    }
    showSite = (record) => {
        this.setState({
            viewVisible: true,
        });
        setTimeout(() => {
            const recordCopy = {...record};
            if (recordCopy.vehicleOption) {
                recordCopy.vehicleOption = recordCopy.vehicleOption.split(',');
            }
            this.viewFormRef.current.setFieldsValue(recordCopy);
        }, 100);
    }
    showEditSite = (record) => {
        this.listBusinessUser(record.userName);
        this.setState({
            editVisible: true,
        });
        setTimeout(() => {
            const recordCopy = {...record};
            if (recordCopy.vehicleOption) {
                recordCopy.vehicleOption = recordCopy.vehicleOption.split(',');
            }
            this.editFormRef.current.setFieldsValue(recordCopy);
        }, 100);
    }
    updateSite = () => {
        this.editFormRef.current.validateFields()
            .then(values => {
                if (Array.isArray(values.vehicleOption)) {
                    values.vehicleOption = values.vehicleOption.join(',');
                }
                let formData = new FormData();
                formData.append('site', new Blob([JSON.stringify(values)], {type: "application/json"}));
                Axios({
                    method: 'post',
                    url: '/site/updateSite',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    data: formData,
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            this.setState({
                                loading: true,
                                editVisible: false,
                            });
                            message.success(res.data.message);
                            this.initData();
                            this.editFormRef.current.resetFields();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            })
            .catch(info => {
                console.log(info);
            });
    }
    showChangeSiteStatus = (record, status) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined/>,
            content: "确认" + (status === 0 ? "启用" : "禁用") + "该站点？",
            onOk: () => {
                Axios({
                    method: 'put',
                    url: '/site/changeSiteStatus/' + record.id,
                    params: {
                        status: status,
                    }
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            message.success(res.data.message);
                            this.initData();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            onCancel: () => {

            },
        });
    }
    showDeleteSite = (record) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined/>,
            content: "确认删除该站点？",
            onOk: () => {
                Axios({
                    method: 'delete',
                    url: '/site/deleteSite/' + record.id,
                    params: {}
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            message.success(res.data.message);
                            this.initData();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            onCancel: () => {

            },
        });
    }
    onSelectChange = (selectedRowKeys) => {
        const selected = this.state.selectedRowKeys;
        if (selectedRowKeys.length > 0) {
            selectedRowKeys.forEach(item => {
                if (selected.indexOf(item) < 0) {
                    selected.push(item);
                }
            });
        }
        this.setState({
            selected: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
            selectedRowKeys: selected.sort(function (a, b) {
                return a - b
            }),
        });
        if (this.state.selectedRowKeys.length === 0) {
            this.setState({
                isCheckAll: false,
                checkboxText: '全选',
            })
        }
    }
    rowOnSelect = (record, selected, selectedRows, nativeEvent) => {
        const selectedRowKeys = this.state.selectedRowKeys;
        if (selected === true) {
            selectedRowKeys.push(record.id);
        } else {
            const index = selectedRowKeys.indexOf(record.id);
            if (index >= 0) {
                selectedRowKeys.splice(index, 1);
            }
        }
        this.setState({
            selected: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
            selectedRowKeys: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
        });
    }
    onSelectAll = (selected, selectedRows, changeRows) => {
        if (!selected) {
            const selectedRowKeys = this.state.selectedRowKeys;
            for (let i = 0; i < changeRows.length; i++) {
                const index = selectedRowKeys.indexOf(changeRows[i].id);
                selectedRowKeys.splice(index, 1);
            }
            this.setState({
                selected: selectedRowKeys.sort(function (a, b) {
                    return a - b
                }),
                selectedRowKeys: selectedRowKeys.sort(function (a, b) {
                    return a - b
                }),
            });
        }
    }
    exportSiteInfo = () => {
        if (this.state.selectedRowKeys.length === 0) {
            message.error("请选择要导出的数据!");
        } else {
            this.setState({
                loading: true,
                isExporting: true,
            })
            Axios({
                method: 'get',
                url: '/site/exportSiteInfo/' + this.state.selectedRowKeys,
                responseType: 'blob'
            }).then(res => {
                if (res.status === 200) {
                    const blob = new Blob([res.data])
                    const downloadElement = document.createElement('a');
                    const href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = '站点数据.xlsx';
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    this.setState({
                        loading: false,
                        isExporting: false,
                    })
                } else if (res.code === 401) {
                    message.error(res.message);
                    this.setState({
                        loading: false,
                        isExporting: false,
                    })
                }
            }).catch(err => {
                console.log(err);
                this.setState({
                    loading: false,
                    isExporting: false,
                })
            });
        }
    }

    handleResize = (key) => (newWidth) => {
        this.setState(prev => ({
            colWidths: {...prev.colWidths, [key]: newWidth},
        }));
    }
    buildResizableColumns = (columns) => {
        return columns.map(col => {
            if (col.key === 'action' || col.children) {
                return col;
            }
            const key = col.key || col.dataIndex;
            return {
                ...col,
                width: this.state.colWidths[key] || col.width || 120,
                ellipsis: col.ellipsis === undefined ? true : col.ellipsis,
                onHeaderCell: () => ({
                    width: this.state.colWidths[key] || col.width || 120,
                    onResize: this.handleResize(key),
                }),
            };
        });
    }

    render() {
        const userRole = JSON.parse(window.sessionStorage.getItem("userRole"));
        const isSiteReadOnly = userRole === 1;
        const rowSelection = {
            selectedRowKeys: [...this.state.selectedRowKeys],
            fixed: true,
            onChange: this.onSelectChange,
            onSelect: this.rowOnSelect,
            onSelectAll: this.onSelectAll
        };
        const layout = {
            labelCol: {span: 8},
            wrapperCol: {span: 16},
        };
        const columns = this.buildResizableColumns([
            {
                title: '站点',
                dataIndex: 'siteName',
                key: 'siteName',
                ellipsis: true,
            },
            // 线上电呼(role=1)不显示"站点电话"列
            ...(userRole === 1 ? [] : [{
                title: '站点电话',
                dataIndex: 'siteTel',
                key: 'siteTel',
            }]),
            {
                title: '站点地址',
                dataIndex: 'address',
                key: 'address',
                ellipsis: true,
            },
            // 线上电呼(role=1)不显示"所属商家"列
            ...(userRole === 1 ? [] : [{
                title: '所属商家',
                dataIndex: 'businessName',
                key: 'businessName',
                ellipsis: true,
            }]),
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                render: status => {
                    switch (status) {
                        case 0:
                            return '启用中';
                        case 1:
                            return '禁用中';
                        default:
                            return '启用中';
                    }
                }
            },
            {
                title: '收费金额',
                dataIndex: 'chargeAmount',
                key: 'chargeAmount',
                render: (value) => (value == null || value === '') ? '' : '¥' + value,
            },
            {
                title: '工作时间',
                dataIndex: 'workTime',
                key: 'workTime',
                ellipsis: true,
            },
            {
                title: '检测站服务内容',
                dataIndex: 'introduce',
                key: 'introduce',
                ellipsis: true,
            },
            {
                title: '特殊说明',
                dataIndex: 'remarks',
                key: 'remarks',
                ellipsis: true,
            },
            {
                title: '检测车型',
                dataIndex: 'vehicleOption',
                key: 'vehicleOption',
                ellipsis: true,
            },
            {
                title: '创建时间',
                dataIndex: 'gmtCreate',
                key: 'gmtCreate',
                ellipsis: true,
                render: (v) => (v ? String(v).substring(0, 10) : '-'),
            },
            {
                title: '操作',
                key: 'action',
                width: 180,
                fixed: 'right',
                render: (text, record) => (
                    <Space size="small">
                        {isSiteReadOnly || (this.state.userPermission != null && this.state.userPermission.includes('300021')) ? (
                            <a onClick={this.showSite.bind(this, record)}>查看</a>) : null
                        }
                        {!isSiteReadOnly && this.state.userPermission != null && this.state.userPermission.includes('300022') ? (
                            <a onClick={this.showEditSite.bind(this, record)}>修改</a>) : null
                        }
                        {!isSiteReadOnly && record.status === 0 ? (this.state.userPermission != null && this.state.userPermission.includes('300023') ? (
                            <a style={{'color': '#f5ce0a'}}
                               onClick={this.showChangeSiteStatus.bind(this, record, 1)}>禁用</a>) : null) : (!isSiteReadOnly && this.state.userPermission != null && this.state.userPermission.includes('300024') ? (
                            <a style={{'color': '#f5ce0a'}}
                               onClick={this.showChangeSiteStatus.bind(this, record, 0)}>启用</a>) : null)}
                        {!isSiteReadOnly && this.state.userPermission != null && this.state.userPermission.includes('300025') ? (
                            <a style={{'color': '#d43f3a'}}
                               onClick={this.showDeleteSite.bind(this, record)}>删除</a>) : null
                        }
                    </Space>
                ),
            },
        ]);

        return (
            <div className={style['content']} id='content'>
                <div className={style['content_info']}>
                    <Form layout='inline' className="filter-form">
                        <Form.Item
                            label="站点名称"
                            name="siteName"
                            style={{width: 220, marginTop: '3px', marginBottom: '3px'}}>
                            <Input placeholder="请输入站点名称"
                                   style={{width: '85%'}}
                                   onChange={this.inputChange}/>
                        </Form.Item>
                        <Form.Item
                            label="状态"
                            name="status"
                            style={{width: 130, marginTop: '3px', marginBottom: '3px'}}>
                            <Select style={{width: '85%'}} allowClear onChange={this.statusChange}>
                                <Select.Option value="0">启用中</Select.Option>
                                <Select.Option value="1">禁用中</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="收费金额"
                            name="chargeAmounts"
                            style={{width: 200, marginTop: '3px', marginBottom: '3px'}}>
                            <Select allowClear style={{width: '85%'}}
                                    placeholder="请选择收费金额"
                                    onChange={this.filterChange('chargeAmounts')}
                                    dropdownMatchSelectWidth={false}
                                    showSearch>
                                {
                                    this.state.filterOptions != null && this.state.filterOptions.chargeAmounts != null ?
                                        this.state.filterOptions.chargeAmounts.map(item => {
                                            return (<Select.Option key={item}
                                                                   value={item}>{item}</Select.Option>)
                                        }) : null
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="工作时间"
                            name="workTimes"
                            style={{width: 200, marginTop: '3px', marginBottom: '3px'}}>
                            <Select allowClear style={{width: '85%'}}
                                    placeholder="请选择工作时间"
                                    onChange={this.filterChange('workTimes')}
                                    dropdownMatchSelectWidth={false}
                                    showSearch>
                                {
                                    this.state.filterOptions != null && this.state.filterOptions.workTimes != null ?
                                        this.state.filterOptions.workTimes.map(item => {
                                            return (<Select.Option key={item}
                                                                   value={item}>{item}</Select.Option>)
                                        }) : null
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="检测站服务内容"
                            name="introduces"
                            style={{width: 220, marginTop: '3px', marginBottom: '3px'}}>
                            <Select allowClear style={{width: '85%'}}
                                    placeholder="请选择服务内容"
                                    onChange={this.filterChange('introduces')}
                                    dropdownMatchSelectWidth={false}
                                    showSearch>
                                {
                                    this.state.filterOptions != null && this.state.filterOptions.introduces != null ?
                                        this.state.filterOptions.introduces.map(item => {
                                            return (<Select.Option key={item}
                                                                   value={item}>{item}</Select.Option>)
                                        }) : null
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="特殊说明"
                            name="specialRemarks"
                            style={{width: 220, marginTop: '3px', marginBottom: '3px'}}>
                            <Select allowClear style={{width: '85%'}}
                                    placeholder="请选择特殊说明"
                                    onChange={this.filterChange('specialRemarks')}
                                    dropdownMatchSelectWidth={false}
                                    showSearch>
                                {
                                    this.state.filterOptions != null && this.state.filterOptions.remarks != null ?
                                        this.state.filterOptions.remarks.map(item => {
                                            return (<Select.Option key={item}
                                                                   value={item}>{item}</Select.Option>)
                                        }) : null
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="检测车型"
                            name="vehicleOptions"
                            style={{width: 200, marginTop: '3px', marginBottom: '3px'}}>
                            <Select allowClear style={{width: '85%'}}
                                    placeholder="请选择检测车型"
                                    onChange={this.filterChange('vehicleOptions')}
                                    dropdownMatchSelectWidth={false}
                                    showSearch>
                                {
                                    this.state.filterOptions != null && this.state.filterOptions.vehicleOptions != null ?
                                        this.state.filterOptions.vehicleOptions.map(item => {
                                            return (<Select.Option key={item}
                                                                   value={item}>{item}</Select.Option>)
                                        }) : null
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            style={{marginTop: '3px', marginBottom: '3px'}}>
                            <Button type="primary" onClick={this.searchSite}
                                    style={{'marginLeft': '10px'}}>查询</Button>
                            <Button type="primary" htmlType="reset" style={{'marginLeft': '10px'}}
                                    onClick={this.resetSearch}>重置</Button>
                            {!isSiteReadOnly && this.state.userPermission != null && this.state.userPermission.includes('300019') ? (
                                <Button type="primary" style={{'marginLeft': '10px'}}
                                        onClick={this.openAddSiteModal}>新增</Button>) : null
                            }
                            {!isSiteReadOnly && this.state.userPermission != null && this.state.userPermission.includes('300020') ? (
                                <Button type="primary" style={{'marginLeft': '10px'}}
                                        onClick={this.exportSiteInfo}
                                        disabled={this.state.isExporting}>导出</Button>) : null
                            }
                        </Form.Item>
                    </Form>
                    <div>
                        <Modal
                            width={700}
                            title={
                                <div
                                    style={{
                                        width: '100%',
                                        cursor: 'move',
                                    }}>
                                    新增
                                </div>
                            }
                            visible={this.state.visible}
                            onOk={this.addSite}
                            onCancel={this.handleCancel}>
                            <Form labelCol={{span: 6}} wrapperCol={{span: 18}}
                                  className="site-modal-form"
                                  ref={this.addFormRef}>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="站点名称"
                                            name="siteName"
                                            rules={[{required: true, message: '请输入站点名称'}]}>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="所属商家"
                                            name="userName"
                                            rules={[{required: true, message: '请选择所属商家'}]}>
                                            <Select dropdownMatchSelectWidth={false}>
                                                {
                                                    this.state.businessUser != null ?
                                                        this.state.businessUser.map(item => {
                                                            return (<Select.Option key={item.userName}
                                                                                   value={item.userName}>{item.realName}</Select.Option>)
                                                        }) : null
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="站点电话"
                                            name="siteTel">
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="站点地址"
                                            name="address">
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="收费金额"
                                            name="chargeAmount">
                                            <InputNumber style={{width: '100%'}}
                                                         min={0}
                                                         precision={2}
                                                         placeholder="请输入收费金额（仅限数字）"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="工作时间"
                                            name="workTime">
                                            <TextArea rows={1}
                                                      autoSize={{minRows: 1, maxRows: 5}}
                                                      placeholder="请填写工作时间（如 08:00-17:00）"/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Form.Item
                                    label="检测站服务内容"
                                    name="introduce"
                                    labelCol={{span: 4}}
                                    wrapperCol={{span: 20}}>
                                    <TextArea rows={2} style={{padding: '4px 8px'}}/>
                                </Form.Item>
                                <Form.Item
                                    label="特殊说明"
                                    name="remarks"
                                    labelCol={{span: 4}}
                                    wrapperCol={{span: 20}}>
                                    <TextArea rows={2} style={{padding: '4px 8px'}}/>
                                </Form.Item>
                                <Form.Item
                                    label="检测车型"
                                    name="vehicleOption"
                                    labelCol={{span: 4}}
                                    wrapperCol={{span: 20}}>
                                    <Checkbox.Group>
                                        <Checkbox value="柴油车">柴油车</Checkbox>
                                        <Checkbox value="黄牌货车">黄牌货车</Checkbox>
                                        <Checkbox value="平板线">平板线</Checkbox>
                                    </Checkbox.Group>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title={
                                <div
                                    style={{
                                        width: '100%',
                                        cursor: 'move',
                                    }}>
                                    查看
                                </div>
                            }
                            visible={this.state.viewVisible}
                            onOk={this.handleCancel}
                            onCancel={this.handleCancel}>
                            <Form {...layout}
                                  ref={this.viewFormRef}>
                                <Form.Item
                                    label="站点名称"
                                    name="siteName">
                                    <Input disabled/>
                                </Form.Item>
                                <Form.Item
                                    label="站点电话"
                                    name="siteTel">
                                    <Input disabled/>
                                </Form.Item>
                                <Form.Item
                                    label="所属商家"
                                    name="businessName">
                                    <Input disabled/>
                                </Form.Item>
                                <Form.Item
                                    label="站点地址"
                                    name="address">
                                    <Input disabled/>
                                </Form.Item>
                                <Form.Item
                                    label="收费金额"
                                    name="chargeAmount">
                                    <InputNumber disabled style={{width: '100%'}}/>
                                </Form.Item>
                                <Form.Item
                                    label="工作时间"
                                    name="workTime">
                                    <TextArea disabled rows={1} autoSize={{minRows: 1, maxRows: 5}}/>
                                </Form.Item>
                                <Form.Item
                                    label="检测站服务内容"
                                    name="introduce">
                                    <TextArea disabled rows={4}/>
                                </Form.Item>
                                <Form.Item
                                    label="特殊说明"
                                    name="remarks">
                                    <TextArea disabled rows={4}/>
                                </Form.Item>
                                <Form.Item
                                    label="检测车型"
                                    name="vehicleOption">
                                    <Checkbox.Group disabled>
                                        <Checkbox value="柴油车">柴油车</Checkbox>
                                        <Checkbox value="黄牌货车">黄牌货车</Checkbox>
                                        <Checkbox value="平板线">平板线</Checkbox>
                                    </Checkbox.Group>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            width={700}
                            title={
                                <div
                                    style={{
                                        width: '100%',
                                        cursor: 'move',
                                    }}>
                                    修改
                                </div>
                            }
                            visible={this.state.editVisible}
                            onOk={this.updateSite}
                            onCancel={this.handleCancel}>
                            <Form labelCol={{span: 6}} wrapperCol={{span: 18}}
                                  className="site-modal-form"
                                  ref={this.editFormRef}>
                                <Form.Item
                                    label="站点ID"
                                    name="id"
                                    hidden="true">
                                    <Input/>
                                </Form.Item>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="站点名称"
                                            name="siteName"
                                            rules={[{required: true, message: '请输入站点名称'}]}>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="所属商家"
                                            name="userName"
                                            rules={[{required: true, message: '请选择所属商家'}]}>
                                            <Select dropdownMatchSelectWidth={false}>
                                                {
                                                    this.state.businessUser != null ?
                                                        this.state.businessUser.map(item => {
                                                            return (<Select.Option key={item.userName}
                                                                                   value={item.userName}>{item.realName}</Select.Option>)
                                                        }) : null
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="站点电话"
                                            name="siteTel">
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="站点地址"
                                            name="address">
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="收费金额"
                                            name="chargeAmount">
                                            <InputNumber style={{width: '100%'}}
                                                         min={0}
                                                         precision={2}
                                                         placeholder="请输入收费金额（仅限数字）"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="工作时间"
                                            name="workTime">
                                            <TextArea rows={1}
                                                      autoSize={{minRows: 1, maxRows: 5}}
                                                      placeholder="请填写工作时间（如 08:00-17:00）"/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Form.Item
                                    label="检测站服务内容"
                                    name="introduce"
                                    labelCol={{span: 4}}
                                    wrapperCol={{span: 20}}>
                                    <TextArea rows={2} style={{padding: '4px 8px'}}/>
                                </Form.Item>
                                <Form.Item
                                    label="特殊说明"
                                    name="remarks"
                                    labelCol={{span: 4}}
                                    wrapperCol={{span: 20}}>
                                    <TextArea rows={2} style={{padding: '4px 8px'}}/>
                                </Form.Item>
                                <Form.Item
                                    label="检测车型"
                                    name="vehicleOption"
                                    labelCol={{span: 4}}
                                    wrapperCol={{span: 20}}>
                                    <Checkbox.Group>
                                        <Checkbox value="柴油车">柴油车</Checkbox>
                                        <Checkbox value="黄牌货车">黄牌货车</Checkbox>
                                        <Checkbox value="平板线">平板线</Checkbox>
                                    </Checkbox.Group>
                                </Form.Item>
                            </Form>
                        </Modal>
                    </div>
                    <Table columns={columns}
                           size="small"
                           className="module-table"
                           dataSource={this.state.data}
                           rowKey={columns => columns.id}
                           rowSelection={rowSelection}
                           loading={this.state.loading}
                           tableLayout="fixed"
                           components={{header: {cell: ResizableTitle}}}
                           scroll={{x: 1300}}
                           style={{'marginTop': '12px'}}
                           pagination={{
                               showTotal: () => `共 ${this.state.total} 条`,
                               onShowSizeChange: (current, pageSize) => {
                                   this.setState({
                                       current: current,
                                       pageSize: pageSize
                                   });
                                   setTimeout(() => {
                                       this.initData();
                                   }, 100);
                               },
                               total: this.state.total,
                               current: this.state.current,
                               pageSize: this.state.pageSize,
                               onChange: (current, pageSize) => {
                                   this.setState({
                                       current: current,
                                       pageSize: pageSize
                                   });
                                   setTimeout(() => {
                                       this.initData();
                                   }, 100);
                               }
                           }}/>
                    <div style={{
                        marginTop: "-38px",
                        marginLeft: "8px",
                        display: (this.state.data === null || this.state.data.length === 0) ? 'none' : ''
                    }}>
                        <Checkbox style={{fontSize: 12}} onChange={this.exportAllSelect}
                                  checked={this.state.isCheckAll}
                                  disabled={this.state.selectAllLoading}>{this.state.checkboxText}</Checkbox><span style={{marginLeft:8,fontSize:12,color:'#606266'}}>已选 <b style={{color:'#1890ff'}}>{this.state.selectedRowKeys.length}</b> 条</span>
                        {
                            this.state.selectAllLoading ? (
                                <span style={{
                                    marginLeft: '8px',
                                    fontSize: '14px',
                                        color: '#67c23a',
                                    verticalAlign: 'middle'
                                }}>全选中 {this.state.selectAllProgress}%</span>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default SiteInfo;
